export default __webpack_public_path__ + "AngloApplicantsUpload_development.xlsx";